'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _some = require('lodash/some');

var _some2 = _interopRequireDefault(_some);

var _every = require('lodash/every');

var _every2 = _interopRequireDefault(_every);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _size = require('lodash/size');

var _size2 = _interopRequireDefault(_size);

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

var _constant = require('lodash/constant');

var _constant2 = _interopRequireDefault(_constant);

var _isUndefined = require('lodash/isUndefined');

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _filter = require('lodash/filter');

var _filter2 = _interopRequireDefault(_filter);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Clearfix = require('react-bootstrap/lib/Clearfix');

var _Clearfix2 = _interopRequireDefault(_Clearfix);

var _DropdownButton = require('react-bootstrap/lib/DropdownButton');

var _DropdownButton2 = _interopRequireDefault(_DropdownButton);

var _MenuItem = require('react-bootstrap/lib/MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _CaretUpSecondary = require('@scoir/brand-icons/dist/CaretUpSecondary');

var _CaretUpSecondary2 = _interopRequireDefault(_CaretUpSecondary);

var _CaretDownSecondary = require('@scoir/brand-icons/dist/CaretDownSecondary');

var _CaretDownSecondary2 = _interopRequireDefault(_CaretDownSecondary);

var _LeftArrowSecondary = require('@scoir/brand-icons/dist/LeftArrowSecondary');

var _LeftArrowSecondary2 = _interopRequireDefault(_LeftArrowSecondary);

var _RightArrowSecondary = require('@scoir/brand-icons/dist/RightArrowSecondary');

var _RightArrowSecondary2 = _interopRequireDefault(_RightArrowSecondary);

var _Pagination = require('../Pagination');

var _Pagination2 = _interopRequireDefault(_Pagination);

var _TableOptions = require('./TableOptions');

var _TableOptions2 = _interopRequireDefault(_TableOptions);

var _TableColumnVisibility = require('./TableColumnVisibility');

var _TableColumnVisibility2 = _interopRequireDefault(_TableColumnVisibility);

var _TablePageSize = require('./TablePageSize');

var _TablePageSize2 = _interopRequireDefault(_TablePageSize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var INVERTED_SORT_LABELS = {
    asc: 'descending',
    desc: 'ascending'
};

var SimpleTable = function (_React$Component) {
    _inherits(SimpleTable, _React$Component);

    function SimpleTable() {
        _classCallCheck(this, SimpleTable);

        return _possibleConstructorReturn(this, (SimpleTable.__proto__ || Object.getPrototypeOf(SimpleTable)).apply(this, arguments));
    }

    _createClass(SimpleTable, [{
        key: 'pageRange',
        value: function pageRange(from, records) {
            var displayableTo = from + (0, _size2.default)(records);
            var displayableFrom = Math.min(from + 1, displayableTo);

            return displayableFrom + ' to ' + displayableTo;
        }
    }, {
        key: 'toggleSort',
        value: function toggleSort(targetSortKey) {
            var sortDir = undefined;
            if (targetSortKey === this.props.sortKey) {
                if (this.props.sortDir === 'asc') {
                    sortDir = 'desc';
                } else {
                    sortDir = 'asc';
                }
            }
            this.props.onSortChange(targetSortKey, sortDir);
        }
    }, {
        key: 'renderActions',
        value: function renderActions() {
            var _props = this.props,
                total = _props.total,
                showSelectedCount = _props.showSelectedCount,
                isSelectingAll = _props.isSelectingAll,
                records = _props.records;

            if ((0, _isEmpty2.default)(this.props.actions)) {
                return null;
            }
            var numSelected = isSelectingAll ? total : (0, _size2.default)((0, _filter2.default)(records, { selected: true }));
            return _react2.default.createElement(
                'span',
                { className: 'bulk-actions-dropdown' },
                _react2.default.createElement(
                    _DropdownButton2.default,
                    { id: 'simple-table-actions-dropdown',
                        title: 'I would like to \u2026' },
                    showSelectedCount && _react2.default.createElement(
                        _MenuItem2.default,
                        { header: true },
                        '(' + numSelected + ' of ' + total + ' selected)'
                    ),
                    showSelectedCount && _react2.default.createElement(_MenuItem2.default, { divider: true }),
                    (0, _map2.default)(this.props.actions, function (action, idx) {
                        return _react2.default.createElement(
                            _MenuItem2.default,
                            {
                                key: idx,
                                disabled: numSelected === 0,
                                onSelect: action.onSelect },
                            action.label
                        );
                    })
                )
            );
        }
    }, {
        key: 'renderRecord',
        value: function renderRecord(record, idx) {
            var _this2 = this;

            var canToggleColumnVisibility = !(0, _isUndefined2.default)(this.props.onChangeColumnVisibility);
            return _react2.default.createElement(
                _react.Fragment,
                null,
                this.props.actions && _react2.default.createElement(
                    'td',
                    { className: 'selector', key: 'select' },
                    _react2.default.createElement('input', { type: 'checkbox',
                        checked: record.selected === true,
                        disabled: !this.props.canToggleRecord(idx),
                        onChange: function onChange() {
                            return _this2.props.onRecordToggle(idx);
                        }
                    })
                ),
                (0, _map2.default)(this.props.columnDefs, function (column, i) {
                    if (!canToggleColumnVisibility || canToggleColumnVisibility && column.display) {
                        return _react2.default.createElement(
                            'td',
                            { key: i },
                            column.renderCell(record)
                        );
                    }
                })
            );
        }
    }, {
        key: 'header',
        value: function header(column) {
            var _this3 = this;

            if (column.sortKey) {
                var sortDir = this.props.sortDir;

                var isAscending = this.props.sortDir === 'asc';
                var isDescending = this.props.sortDir === 'desc';
                var isBeingSorted = this.props.sortKey === column.sortKey;
                var showAscending = isBeingSorted && isAscending || !isBeingSorted;
                var showDescending = isBeingSorted && isDescending || !isBeingSorted;
                return _react2.default.createElement(
                    'span',
                    { className: 'sortable-header',
                        role: 'button',
                        tabIndex: '0',
                        'aria-label': column.headerText + ' - Sort in ' + (0, _get2.default)(INVERTED_SORT_LABELS, sortDir, '') + ' order',
                        onKeyDown: function onKeyDown(e) {
                            return e.key === 'Enter' && _this3.toggleSort(column.sortKey);
                        },
                        onClick: function onClick() {
                            return _this3.toggleSort(column.sortKey);
                        } },
                    column.headerText,
                    _react2.default.createElement(
                        'span',
                        { className: 'sort-indicator' },
                        showAscending && _react2.default.createElement(_CaretUpSecondary2.default, { className: (0, _classnames2.default)('arrow arrow-up', { inactive: !isBeingSorted }) }),
                        showDescending && _react2.default.createElement(_CaretDownSecondary2.default, { className: (0, _classnames2.default)('arrow arrow-down', { inactive: !isBeingSorted }) })
                    )
                );
            }
            return column.headerText;
        }
    }, {
        key: 'hasFixedWidth',
        value: function hasFixedWidth(columnDefs) {
            return (0, _some2.default)(columnDefs, 'width');
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var canToggleColumnVisibility = !(0, _isUndefined2.default)(this.props.onChangeColumnVisibility);
            return _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)('table-comp', { compact: this.props.compact }) },
                _react2.default.createElement(
                    _Clearfix2.default,
                    { className: 'table-actions' },
                    this.renderActions(),
                    _react2.default.createElement(
                        'div',
                        { className: 'control-panel-container' },
                        this.props.controlPanel
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'table-options' },
                        this.props.canFilter && _react2.default.createElement(_TableOptions2.default, {
                            filter: this.props.filter,
                            onFilterChange: this.props.onFilterChange }),
                        this.props.canChangePageSize && _react2.default.createElement(_TablePageSize2.default, { pageSize: this.props.pageSize,
                            onPageSizeChange: this.props.onPageSizeChange }),
                        canToggleColumnVisibility && _react2.default.createElement(_TableColumnVisibility2.default, {
                            columnDefs: this.props.columnDefs,
                            onChangeColumnVisibility: this.props.onChangeColumnVisibility })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)('table-container', this.props.tableContainerClass, {
                            'table-fixed-width': this.hasFixedWidth(this.props.columnDefs),
                            'ct-sticky-header': this.props.stickyHeaders
                        }) },
                    _react2.default.createElement(
                        'table',
                        null,
                        _react2.default.createElement(
                            'thead',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                this.props.actions && _react2.default.createElement(
                                    'th',
                                    { className: 'selector', key: 'select-all' },
                                    this.props.onToggleAll && _react2.default.createElement('input', { type: 'checkbox',
                                        disabled: !this.props.canToggleAll(),
                                        checked: (0, _isUndefined2.default)(this.props.isSelectingAll) ? (0, _size2.default)(this.props.records) > 0 && (0, _every2.default)(this.props.records, { selected: true }) : this.props.isSelectingAll,
                                        onChange: function onChange(e) {
                                            return _this4.props.onToggleAll(e.target.checked);
                                        }
                                    })
                                ),
                                (0, _map2.default)(this.props.columnDefs, function (column, i) {
                                    var style = {
                                        width: column.width
                                    };
                                    if (!canToggleColumnVisibility || canToggleColumnVisibility && column.display) {
                                        return _react2.default.createElement(
                                            'th',
                                            { key: i, style: style },
                                            _this4.header(column)
                                        );
                                    }
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'tbody',
                            null,
                            (0, _map2.default)(this.props.records, function (record, idx) {
                                var key = record[_this4.props.keyedBy];
                                if (typeof _this4.props.keyedBy === 'function') {
                                    key = _this4.props.keyedBy(record);
                                }
                                return _react2.default.createElement(
                                    'tr',
                                    { key: key },
                                    _this4.renderRecord(record, idx)
                                );
                            })
                        )
                    )
                ),
                this.props.paginated && _react2.default.createElement(
                    'div',
                    { className: 'table-results-footer clearfix' },
                    _react2.default.createElement(
                        'div',
                        { className: 'pull-right' },
                        _react2.default.createElement(_Pagination2.default, {
                            bsSize: 'small',
                            maxButtons: 5,
                            boundaryLinks: true,
                            items: Math.ceil(this.props.total / this.props.pageSize),
                            first: _react2.default.createElement(_LeftArrowSecondary2.default, null),
                            last: _react2.default.createElement(_RightArrowSecondary2.default, null),
                            activePage: Math.ceil(this.props.from / this.props.pageSize) + 1,
                            onSelect: function onSelect(pageNumber) {
                                return _this4.props.onPageChange(pageNumber);
                            }
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'results-summary pull-left' },
                        'Showing',
                        this.props.paginated && _react2.default.createElement(
                            'span',
                            { className: 'page-range' },
                            ' ',
                            _react2.default.createElement(
                                'b',
                                null,
                                this.pageRange(this.props.from, this.props.records)
                            ),
                            ' of'
                        ),
                        _react2.default.createElement(
                            'em',
                            null,
                            ' ',
                            this.props.total || 0,
                            ' Result',
                            this.props.total !== 1 ? 's' : ''
                        )
                    )
                )
            );
        }
    }]);

    return SimpleTable;
}(_react2.default.Component);

SimpleTable.defaultProps = {
    records: [],
    paginated: true,
    canFilter: false,
    canChangePageSize: false,
    canHideColumns: false,
    canToggleRecord: (0, _constant2.default)(true),
    canToggleAll: (0, _constant2.default)(true),
    compact: false
};

SimpleTable.propTypes = {
    total: _propTypes2.default.number,
    from: _propTypes2.default.number,
    pageSize: _propTypes2.default.number,
    paginated: _propTypes2.default.bool,
    keyedBy: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
    columnDefs: _propTypes2.default.array.isRequired,
    records: _propTypes2.default.array.isRequired,
    actions: _propTypes2.default.array,
    controlPanel: _propTypes2.default.node,
    onPageChange: _propTypes2.default.func,
    onSortChange: _propTypes2.default.func,
    sortKey: _propTypes2.default.string,
    sortDir: _propTypes2.default.oneOf(['asc', 'desc']),
    filter: _propTypes2.default.string,
    onFilterChange: _propTypes2.default.func,
    onPageSizeChange: _propTypes2.default.func,
    canChangePageSize: _propTypes2.default.bool,
    canFilter: _propTypes2.default.bool,
    onRecordToggle: _propTypes2.default.func,
    canToggleRecord: _propTypes2.default.func,
    onToggleAll: _propTypes2.default.func,
    isSelectingAll: _propTypes2.default.bool,
    showSelectedCount: _propTypes2.default.bool,
    onChangeColumnVisibility: _propTypes2.default.func,
    canToggleAll: _propTypes2.default.func,
    compact: _propTypes2.default.bool,
    stickyHeaders: _propTypes2.default.bool,
    tableContainerClass: _propTypes2.default.string
};

exports.default = SimpleTable;
//# sourceMappingURL=SimpleTable.js.map